<template>
  <div class="nav-bar">
    <el-row>
      <el-col :span="12">
        <el-menu 
          ref="menu"
          class="el-menu-vertical-demo" 
          @open="handleOpen" 
          @close="handleClose" 
          background-color="#3a3c48" 
          text-color="#fff" 
          active-text-color="#ffd04b" 
          :default-active="_path" 
          router
          :unique-opened="true"
        >
          <!-- 用户&数据 -->
          <el-submenu index="user-data">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>用户&数据</span>
            </template>
            <el-menu-item index="/">
              <i class="el-icon-user"></i>
              <span>用户管理</span>
            </el-menu-item>
            <el-menu-item index="/userGrouping">
              <i class="el-icon-s-grid"></i>
              <span>用户分组</span>
            </el-menu-item>
            <el-menu-item index="/userTask">
              <i class="el-icon-office-building"></i>
              <span>用户任务计划</span>
            </el-menu-item>
            <el-menu-item index="/userGroupTask">
              <i class="el-icon-receiving"></i>
              <span>用户组任务计划</span>
            </el-menu-item>
            <el-menu-item index="/maintenance-data">
              <i class="el-icon-s-grid"></i>
              <span>数据管理</span>
            </el-menu-item>
            <el-menu-item index="/taskData">
              <i class="el-icon-document-copy"></i>
              <span>任务列表</span>
            </el-menu-item>
          </el-submenu>
          
          <!-- 订单中心 -->
          <el-submenu index="order-center">
            <template slot="title">
              <i class="el-icon-shopping-cart-full"></i>
              <span>订单中心</span>
            </template>
            <el-menu-item index="/order-list">
              <i class="el-icon-s-order"></i>
              <span>订单列表</span>
            </el-menu-item>
            <el-menu-item index="/sales-refund">
              <i class="el-icon-refresh-left"></i>
              <span>售后退款</span>
            </el-menu-item>
          </el-submenu>
          
          <!-- 记录相关 -->
          <el-submenu index="records">
            <template slot="title">
              <i class="el-icon-document"></i>
              <span>记录查询</span>
            </template>
            <el-menu-item index="/game-manage">
              <i class="el-icon-s-management"></i>
              <span>游戏管理</span>
            </el-menu-item>
            <el-menu-item index="/evaluation-list">
              <i class="el-icon-s-claim"></i>
              <span>运动测评</span>
            </el-menu-item>
            <el-menu-item index="/play-record">
              <i class="el-icon-video-camera"></i>
              <span>播放记录</span>
            </el-menu-item>
            <el-menu-item index="/deBug">
              <i class="el-icon-warning-outline"></i>
              <span>deBug记录</span>
            </el-menu-item>
            <el-menu-item index="/yesterdayReport">
              <i class="el-icon-s-order"></i>
              <span>昨日报告</span>
            </el-menu-item>
          </el-submenu>
          
          <!-- 问卷管理 -->
          <el-submenu index="questionnaire">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span>问卷管理</span>
            </template>
            <el-menu-item index="/test-record">
              <i class="el-icon-tickets"></i>
              <span>答题记录</span>
            </el-menu-item>
            <el-menu-item index="/test-list">
              <i class="el-icon-s-order"></i>
              <span>问卷管理</span>
            </el-menu-item>
            <el-menu-item index="/test-variety">
              <i class="el-icon-s-shop"></i>
              <span>问卷种类</span>
            </el-menu-item>
          </el-submenu>
          
          <!-- 文章管理 -->
          <el-submenu index="articles">
            <template slot="title">
              <i class="el-icon-document"></i>
              <span>文章管理</span>
            </template>
            <el-menu-item index="/article-list">
              <i class="el-icon-document"></i>
              <span>文章列表</span>
            </el-menu-item>
            <el-menu-item index="/article-variety">
              <i class="el-icon-s-shop"></i>
              <span>文章种类</span>
            </el-menu-item>
          </el-submenu>
          
          <!-- 财务管理 -->
          <el-submenu index="finance">
            <template slot="title">
              <i class="el-icon-coin"></i>
              <span>财务管理</span>
            </template>
            <el-menu-item index="/financial-statistics">
              <i class="el-icon-s-data"></i>
              <span>财务统计</span>
            </el-menu-item>
          </el-submenu>
          
          <!-- 主题对话 -->
          <el-submenu index="theme">
            <template slot="title">
              <i class="el-icon-c-scale-to-original"></i>
              <span>主题对话</span>
            </template>
            <el-menu-item index="/themeDialogue">
              <i class="el-icon-c-scale-to-original"></i>
              <span>主题对话</span>
            </el-menu-item>
            <el-menu-item index="/themeDialogueScore">
              <i class="el-icon-thumb"></i>
              <span>情绪打分</span>
            </el-menu-item>
          </el-submenu>
          
          <!-- 其他 -->
          <el-submenu index="others">
            <template slot="title">
              <i class="el-icon-more"></i>
              <span>其他</span>
            </template>
            <el-menu-item index="/share-clicks-number">
              <i class="el-icon-share"></i>
              <span>分享页面点击次数</span>
            </el-menu-item>
            <el-menu-item index="/city-look-and-revise">
              <i class="el-icon-location"></i>
              <span>城市群管理</span>
            </el-menu-item>
            <el-menu-item index="/community-management">
              <i class="el-icon-tickets"></i>
              <span>社区管理</span>
            </el-menu-item>
            <el-menu-item index="/BAccountRegistration">
              <i class="el-icon-s-promotion"></i>
              <span>B端账户注册</span>
            </el-menu-item>
            <el-menu-item index="/user-data-eachars">
              <i class="el-icon-data-board"></i>
              <span>用户分布</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_router: true,
      isShowMore: true,
      // 菜单配置数据
      menuList: [
        {
          index: 'user-data',
          title: '用户&数据',
          icon: 'el-icon-user-solid',
          children: [
            { index: '/', title: '用户管理', icon: 'el-icon-user' },
            { index: '/userGrouping', title: '用户分组', icon: 'el-icon-s-grid' },
            { index: '/userTask', title: '用户任务计划', icon: 'el-icon-office-building' },
            { index: '/userGroupTask', title: '用户组任务计划', icon: 'el-icon-receiving' },
            { index: '/maintenance-data', title: '数据管理', icon: 'el-icon-s-grid' },
            { index: '/taskData', title: '任务列表', icon: 'el-icon-document-copy' }
          ]
        },
        {
          index: 'order-center',
          title: '订单中心',
          icon: 'el-icon-shopping-cart-full',
          children: [
            { index: '/order-list', title: '订单列表', icon: 'el-icon-s-order' },
            { index: '/sales-refund', title: '售后退款', icon: 'el-icon-refresh-left' }
          ]
        },
        {
          index: 'records',
          title: '记录查询',
          icon: 'el-icon-document',
          children: [
            { index: '/game-manage', title: '游戏管理', icon: 'el-icon-s-management' },
            { index: '/evaluation-list', title: '运动测评', icon: 'el-icon-s-claim' },
            { index: '/play-record', title: '播放记录', icon: 'el-icon-video-camera' },
            { index: '/deBug', title: 'deBug记录', icon: 'el-icon-warning-outline' },
            { index: '/yesterdayReport', title: '昨日报告', icon: 'el-icon-s-order' }
          ]
        },
        {
          index: 'questionnaire',
          title: '问卷管理',
          icon: 'el-icon-s-order',
          children: [
            { index: '/test-record', title: '答题记录', icon: 'el-icon-tickets' },
            { index: '/test-list', title: '问卷管理', icon: 'el-icon-s-order' },
            { index: '/test-variety', title: '问卷种类', icon: 'el-icon-s-shop' }
          ]
        },
        {
          index: 'articles',
          title: '文章管理',
          icon: 'el-icon-document',
          children: [
            { index: '/article-list', title: '文章列表', icon: 'el-icon-document' },
            { index: '/article-variety', title: '文章种类', icon: 'el-icon-s-shop' }
          ]
        },
        {
          index: 'finance',
          title: '财务管理',
          icon: 'el-icon-coin',
          children: [
            { index: '/financial-statistics', title: '财务统计', icon: 'el-icon-s-data' }
          ]
        },
        {
          index: 'theme',
          title: '主题对话',
          icon: 'el-icon-c-scale-to-original',
          children: [
            { index: '/themeDialogue', title: '主题对话', icon: 'el-icon-c-scale-to-original' },
            { index: '/themeDialogueScore', title: '情绪打分', icon: 'el-icon-thumb' }
          ]
        },
        {
          index: 'others',
          title: '其他',
          icon: 'el-icon-more',
          children: [
            { index: '/share-clicks-number', title: '分享页面点击次数', icon: 'el-icon-share' },
            { index: '/city-look-and-revise', title: '城市群管理', icon: 'el-icon-location' },
            { index: '/community-management', title: '社区管理', icon: 'el-icon-tickets' },
            { index: '/BAccountRegistration', title: 'B端账户注册', icon: 'el-icon-s-promotion' },
            { index: '/user-data-eachars', title: '用户分布', icon: 'el-icon-data-board' }
          ]
        }
      ],
      // 当前打开的菜单索引
      activeMenu: 'user-data'
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log('菜单打开', key, keyPath);
      // 设置当前打开的菜单
      this.activeMenu = key;
      
      // 使用Element UI API关闭其他菜单
      this.closeOtherMenus(key);
    },
    handleClose(key, keyPath) {
      // console.log('菜单关闭', key, keyPath);
    },
    // 关闭其他所有菜单
    closeOtherMenus(currentKey) {
      // 通过$refs获取菜单实例
      const menu = this.$refs.menu;
      if (!menu) return;
      
      // 获取所有打开的菜单
      const openedKeys = menu.openedKeys;
      if (!openedKeys.length) return;
      
      // 关闭除当前菜单外的所有菜单
      const newOpenedKeys = openedKeys.filter(key => key === currentKey);
      menu.openedKeys = newOpenedKeys;
    },
    // 检查用户权限
    hasPermission(permission) {
      // 实际项目中应该从store或localStorage获取用户权限
      return true; // 示例返回值
    }
  },
  computed: {
    _path() {
      // 重置localStorage
      if (this.$route.path === '/') {
        localStorage.removeItem('phoneNumber');
      }
      
      // 处理二级菜单激活逻辑
      const currentPath = this.$route.path;
      
      // 用户管理相关页面
      if (['/user-info', '/user-info/game', '/user-information'].includes(currentPath)) {
        return '/';
      }
      
      // 游戏管理相关页面
      if (['/game-manage/info', '/game-manage/info/user', '/game-manage/user'].includes(currentPath)) {
        return '/game-manage';
      }
      
      // 文章管理相关页面
      if (['/article-add', '/article-edit'].includes(currentPath)) {
        return '/article-list';
      }
      
      // 答题记录相关页面
      if (['/test-info'].includes(currentPath)) {
        return '/test-record';
      }
      
      // 问卷管理相关页面
      if (['/test-add', '/test-edit'].includes(currentPath)) {
        return '/test-list';
      }
      
      // 用户分布相关页面
      if (['/user-data-eachars/age', '/user-data-eachars/region'].includes(currentPath)) {
        return '/user-data-eachars';
      }
      
      // 其他页面直接返回当前路径
      return currentPath;
    }
  },
  mounted() {
    // 默认打开第一个菜单
    this.$nextTick(() => {
      const menu = this.$refs.menu;
      if (menu) {
        menu.openedKeys = ['user-data'];
      }
    });
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.nav-bar
  position absolute
  width 214px
  top 52px
  left 0
  bottom 0
  background-color #3A3C48
  overflow auto
  transition all 0.3s ease
  
  .el-col-12
    width 100%
    .el-menu
      border none
      background-color transparent
      
      // 一级菜单样式
      .el-submenu
        .el-submenu__title
          height 48px
          line-height 48px
          padding-left 20px
          color #ccc
          &:hover
            background-color rgba(255, 255, 255, 0.1)
            color #fff
          &.is-active
            color #ffd04b
            background-color rgba(0, 0, 0, 0.2)
          
        .el-submenu__icon-arrow
          color #888
          right 20px
          
        // 二级菜单项
        .el-menu-item
          height 42px
          line-height 42px
          padding-left 40px
          background-color #4A4C58
          &:hover
            background-color rgba(255, 255, 255, 0.1)
          &.is-active
            background-color rgba(0, 0, 0, 0.2)
            
      // 菜单折叠状态样式
      &.el-menu--collapse
        width 64px
        .el-submenu
          .el-submenu__title
            padding-left 20px
            span
              display none
          .el-submenu__icon-arrow
            display none
            
        .el-menu-item
          padding-left 20px
          span
            display none
</style>


// WEBPACK FOOTER //
// src/components/NavBar/NavBar.vue